import { useContext, useState } from "react";
import Logo from "../../../assets/img/logo.svg";
import { AuthContext } from "../../../context/AuthContext";

const RegisterPage = () => {
  const { states, actions } = useContext(AuthContext);
  const { loading, error } = states;
  const { handleRegister, setError } = actions;

  const [input, setInput] = useState({
    name: "",
    image_url: "",
    email: "",
    password: "",
  });
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
    setError("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    await handleRegister(input);
    setSuccess(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <img src={Logo} alt="Marikerja" className="h-10" />
          </div>

          <h1 className="text-2xl font-semibold text-center text-gray-800 mb-2">
            Buat Akun Baru
          </h1>
          <p className="text-sm text-gray-500 text-center mb-6">
            Daftar untuk mulai menggunakan Marikerja
          </p>

          {success && (
            <div className="text-green-600 text-center mb-4">
              Registrasi berhasil 🎉
            </div>
          )}

          <form onSubmit={onSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              value={input.name}
              onChange={handleChange}
              placeholder="Nama Lengkap"
              required
              className="w-full rounded-lg border px-4 py-2.5"
            />
            <input
              type="url"
              name="image_url"
              value={input.image_url}
              onChange={handleChange}
              placeholder="URL Foto Profil"
              required
              className="w-full rounded-lg border px-4 py-2.5"
            />
            <input
              type="email"
              name="email"
              value={input.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className="w-full rounded-lg border px-4 py-2.5"
            />
            <input
              type="password"
              name="password"
              value={input.password}
              onChange={handleChange}
              placeholder="Password"
              required
              className="w-full rounded-lg border px-4 py-2.5"
            />
            {error && (
              <p className="text-red-600 text-sm text-center">{error}</p>
            )}
            <button
              type="submit"
              disabled={loading}
              className={`w-full rounded-lg py-2.5 text-white ${
                loading ? "bg-gray-400" : "bg-indigo-600 hover:bg-indigo-950"
              }`}>
              {loading ? "Memproses..." : "Daftar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
